import axios from "axios";

// Use same-origin API calls so the session cookie is first-party.
// iOS Safari ITP blocks 3rd-party cookies on cross-origin XHR calls,
// which broke Shawna's dashboard on iPhone. Calling /api on the same
// host (handled by the Kubernetes ingress) keeps the cookie first-party.
// We fall back to REACT_APP_BACKEND_URL only for non-browser test
// environments.
const SAME_ORIGIN =
    typeof window !== "undefined" && window.location && window.location.origin
        ? window.location.origin
        : null;

export const BACKEND_URL = SAME_ORIGIN || process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
    timeout: 15000,
});
